import ElectronicSystems from './ElectronicSystems'

export default ElectronicSystems
